import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AgentList } from 'api/agent/types';

interface AgentListState {
  agentListInfo: AgentList;
  agentListCurPage: number;
  sortType: string;
  tierFilter: string;
  statusFilter: string;
  loading: boolean;
  scrollLoading: boolean;
  isChangeFilter: number;
}

const initialState: AgentListState = {
  agentListInfo: {
    has_next: false,
    list: [],
    page: 1,
    size: 20,
    total: -1,
  },
  agentListCurPage: 1,
  sortType: 'elo',
  tierFilter: '',
  statusFilter: '',
  loading: false,
  scrollLoading: false,
  isChangeFilter: -1,
};

export const agentListSlice = createSlice({
  name: 'agentListSlice',
  initialState,
  reducers: {
    setAgentListInfo: (state, action: PayloadAction<AgentList>) => {
      state.agentListInfo.has_next = action.payload?.has_next;
      state.agentListInfo.list =
        state.agentListCurPage === 1
          ? action.payload?.list || []
          : state.agentListCurPage === action.payload?.page
          ? state.agentListInfo.list.concat(action.payload?.list)
          : action.payload?.list;
      state.agentListInfo.page = action.payload?.page;
      state.agentListInfo.total = action.payload?.total;
    },
    setAgentListCurPage: (state, action: PayloadAction<number>) => {
      state.agentListCurPage = action.payload;
    },
    setSortType: (state, action: PayloadAction<string>) => {
      state.sortType = action.payload;
    },
    setTierFilter: (state, action: PayloadAction<string>) => {
      state.tierFilter = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string>) => {
      state.statusFilter = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setScrollLoading: (state, action: PayloadAction<boolean>) => {
      state.scrollLoading = action.payload;
    },
    setIsChangeFilter: (state, action: PayloadAction<number>) => {
      state.isChangeFilter = action.payload;
    },
  },
});

export const {
  setAgentListInfo,
  setAgentListCurPage,
  setSortType,
  setTierFilter,
  setStatusFilter,
  setLoading,
  setScrollLoading,
  setIsChangeFilter,
} = agentListSlice.actions;

export default agentListSlice.reducer;
